<template>
  <div>
    <TableColumnSelector
      :show="showTableColumnSelector"
      @hide="showTableColumnSelector = false"
      v-model="headers"
      :skip="['actions']"
    ></TableColumnSelector>
    <v-data-table
      :loading="loading"
      :items="items"
      :no-data-text="$t('projects.extractedROIs.table.empty')"
      :headers="selectedHeaders"
      :footer-props="footerProps"
      disable-sorting
    >
      <template v-slot:header.actions="{}">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              small
              @click.stop.prevent="showTableColumnSelector = true"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>
            {{ $t("components.tableColumnSelector.tooltip") }}
          </span>
        </v-tooltip>
      </template>
      <template v-slot:item.status="{ item }">
        {{ mapStatus(item) }}
      </template>

      <template v-slot:item.created="{ item }">
        {{ item.created | formatDate }}
      </template>
      <template v-slot:item.annotationClass="{ item }">
        {{ getAnnotationClassNames(item) }}
      </template>
      <template v-slot:item.slide="{ item }">
        {{ item.wsi.id }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn icon small :disabled="!item.download_id" @click="download(item)"
          ><v-icon>mdi-download</v-icon></v-btn
        >
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { fetchRoiExtractions } from "@/api/craiyon";
import TableColumnSelector from "@/components/TableColumnSelector";

export default {
  props: {
    project: { required: true }
  },
  data() {
    return {
      showTableColumnSelector: false,
      options: undefined,
      result: null,
      loading: false
    };
  },
  computed: {
    ...mapGetters({ token: "token" }),
    items() {
      if (!this.result) return [];
      return this.result.results;
    },
    footerProps() {
      return {
        "items-per-page-options": [5, 10, 15],
        "items-per-page-text": this.$t("projects.extractedROIs.table.footerText")
      }
    },
    headers() {
      return [
        { text: this.$t("projects.extractedROIs.table.id"), value: "id", visible: false },
        { text: this.$t("projects.extractedROIs.table.dateAdded"), value: "created", visible: true },
        { text: this.$t("projects.extractedROIs.table.slide"), value: "slide", visible: true },
        { text: this.$t("projects.extractedROIs.table.annotationClasses"), value: "annotationClass", visible: true },
        { text: this.$t("projects.extractedROIs.table.status"), value: "status", visible: true },
        { text: this.$t("projects.extractedROIs.table.actions"), value: "actions", visible: true }
      ]
    },
    length() {
      if (!this.result) return 0;
      return this.result.count;
    },
    selectedHeaders() {
      return this.headers.filter(e => e.visible);
    }
    // ...mapState({
    //     loading: state => state.slides.loading,
    //     slides: state => state.slides.slides
    //   }),
    // ...mapGetters({
    //     total: TOTAL,
    //     list: LIST,
    //     imagingStudy: FIND
    //   }),
    //       selectedHeaders() {
    //     return this.headers.filter(e => e.visible);
    //   }
  },
  watch: {
    // headers: {
    //   deep: true,
    //   handler(val) {
    //     this.$dp.store(TABLE_HEADER_SLIDE_MANAGEMENT, val, true);
    //   }
    // },
    // options(newVal, oldVal) {
    //   // do not search if rendered the first time
    //   if (oldVal) {
    //     if (
    //         newVal.itemsPerPage !== oldVal.itemsPerPage ||
    //         newVal.page !== oldVal.page
    //     ) {
    //       this.$store.dispatch(LOAD_SLIDES, newVal);
    //     }
    //   }
    // }
  },
  methods: {
    downloadLink(item) {
      return `${process.env.VUE_APP_CRAIYON_API}media/${item.download_id}.zip`;
    },
    async download(item) {
      const url = `${process.env.VUE_APP_CRAIYON_API}slides/api/download?id=${item.download_id}`;
      window.open(url);
      // await fetch(url, {
      //   method: "post",
      //   headers: {
      //     Authorization: "Bearer " + this.token
      //   }
      // });
    },
    mapStatus(item) {
      if (!item.download_id) {
        return "In process";
      }
      return "Finished";
    },
    getAnnotationClassNames(item) {
      return item.annotation_classes.map(e => e.class_name).join(", ");
    }
  },
  async created() {
    this.loading = true;
    this.result = await fetchRoiExtractions(this.token, this.project);
    console.log(this.result);
    this.loading = false;
  },
  components: { TableColumnSelector }
};
</script>

<style scoped></style>
